import React from 'react'
import { AppLayout, SideNavigation } from 'AWS-UI-Components-React'
import Contracts from '../Contracts/List'
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import Contract from '../Contracts/Details'
import CreateContract from '../Contracts/Create'
import FlashMessage from '../FlashMessage'
import SellerLookup from '../Seller/Lookup'

export default class AppView extends React.PureComponent {
    render() {
        return (
            <div className="awsui">
                <ul id="h" className="menu-list">
                    <li className="selected"><a href="/">Seremto</a></li>
                </ul>
                <div className="appview-container">
                    <AppLayout
                        className='awsui-util-no-gutters'
                        content={this.renderContent()}
                        navigation={this.renderNavigation()}
                        navigationOpen={false}
                        toolsHide
                    />
                </div>
            </div>
        )
    }

    renderContent() {
        return (
            <div>
                <div className='awsui-grid awsui-util-p-s'>
                    <div className='col-xxs-12'>
                        <div className='col-xxs-10 offset-xxs-1 col-s-10 col-l-8 offset-l-2 col-xl-6'>
                            <FlashMessage/>
                            {this.renderRoutes()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderNavigation() {
        return (
            <SideNavigation activeHref={"#/" + this.props.path.split('/')[1]} 
                items={[
                { type: "link", text: "Contracts", href: "#/contracts" },
                { type: "link", text: "Seller Lookup", href: "#/seller" },
                { type: "divider" }
              ]}></SideNavigation>
        )
    }

    renderRoutes() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" render={() => (
                        <Redirect to="/contracts"/>
                    )} />
                    <Route exact path="/contracts" component={Contracts} />
                    <Route exact path="/contracts/:contractId" render={({match}) => <Contract path={match.path} contractId={match.params.contractId}/>} />
                    <Route exact path="/contract/create" component={CreateContract} />
                    <Route exact path="/seller" component={SellerLookup} />
                </Switch>
            </Router>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/App/AppView.jsx